import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles, rootVariablesStyles } from '@/styles';
@customElement('fg-loader')
export class FgLoader extends LitElement {
  @property({ type: String })
  type = 'configurator';

  @property({ type: String })
  label: string | null = '';

  @property({ type: String })
  bgcolor?: string;

  render() {
    return html`
      <div
        class="${`loading-placeholder loading-placeholder--${this.type}`}"
        style="${`background-color: ${this.bgcolor ? this.bgcolor : '#ffffff'}`}"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        ${this.label
          ? html`
              <p>${this.label}</p>
            `
          : null}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    rootVariablesStyles,
    css`
      .loading-placeholder {
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        display: grid;
        place-content: center;
        text-align: center;
        width: 100%;
        z-index: 999;
      }
      .loading-placeholder--configurator {
        height: 100vh;
      }
      .loading-placeholder--configuration {
        height: 200px;
      }
      .loading-placeholder--uploader {
        height: 180px;
      }

      .loading-placeholder--in-component {
        position: absolute;
        height: 100%;
        opacity: 0.8;
        inset: 0;
      }

      .loading-placeholder--in-page {
        background: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(5px);
        position: fixed;
        inset: 0;
      }
      .loading-placeholder img {
        margin: 0 auto;
      }
      .loading-placeholder p {
        margin-top: 2em;
      }

      /* .lds-spinner via https://loading.io/css/ */
      .lds-spinner {
        color: official;
        display: inline-block;
        height: 80px;
        margin: 0 auto;
        position: relative;
        width: 80px;
      }
      .lds-spinner div {
        animation: lds-spinner 1.2s linear infinite;
        transform-origin: 40px 40px;
      }
      .lds-spinner div:after {
        background: var(--fg-primary, var(--fg-fallback-primary));
        border-radius: 20%;
        content: ' ';
        display: block;
        height: 18px;
        left: 37px;
        position: absolute;
        top: 3px;
        width: 6px;
      }
      .lds-spinner div:nth-child(1) {
        animation-delay: -1.1s;
        transform: rotate(0deg);
      }
      .lds-spinner div:nth-child(2) {
        animation-delay: -1s;
        transform: rotate(30deg);
      }
      .lds-spinner div:nth-child(3) {
        animation-delay: -0.9s;
        transform: rotate(60deg);
      }
      .lds-spinner div:nth-child(4) {
        animation-delay: -0.8s;
        transform: rotate(90deg);
      }
      .lds-spinner div:nth-child(5) {
        animation-delay: -0.7s;
        transform: rotate(120deg);
      }
      .lds-spinner div:nth-child(6) {
        animation-delay: -0.6s;
        transform: rotate(150deg);
      }
      .lds-spinner div:nth-child(7) {
        animation-delay: -0.5s;
        transform: rotate(180deg);
      }
      .lds-spinner div:nth-child(8) {
        animation-delay: -0.4s;
        transform: rotate(210deg);
      }
      .lds-spinner div:nth-child(9) {
        animation-delay: -0.3s;
        transform: rotate(240deg);
      }
      .lds-spinner div:nth-child(10) {
        animation-delay: -0.2s;
        transform: rotate(270deg);
      }
      .lds-spinner div:nth-child(11) {
        animation-delay: -0.1s;
        transform: rotate(300deg);
      }
      .lds-spinner div:nth-child(12) {
        animation-delay: 0s;
        transform: rotate(330deg);
      }
      .loading-placeholder--small {
        height: 46px;
        background: transparent;
      }
      .loading-placeholder--small .lds-spinner {
        height: 30px;
        width: 30px;
      }
      .loading-placeholder--small .lds-spinner div {
        transform-origin: 15px 15px;
      }
      .loading-placeholder--small .lds-spinner div:after {
        background: #fff;
        height: 6px;
        left: 14px;
        width: 3px;
      }
      @keyframes lds-spinner {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }

      @media screen and (max-width: ${BREAKPOINT_MEDIUM_PX - 1}px) {
        .loading-placeholder--configurator {
          max-height: 250px;
        }
      }
    `,
  ];
}
